<h2 mat-dialog-title>{{ 'DELETE_KNOWLEDGE.TITLE' | translate }}</h2>
<mat-dialog-content>
  @if (isLoading()) {
    <glxy-loading-spinner></glxy-loading-spinner>
  } @else {
    @if (associatedApps().length > 0) {
      <div>{{ 'APPS_WARNING' | translate }}</div>
      <ai-knowledge-application-list [apps]="associatedApps()" [hideRemove]="true"></ai-knowledge-application-list>
    } @else {
      {{ 'NO_APPS' | translate }}
    }
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-flat-button color="warn" (click)="delete()">{{ 'COMMON.DELETE' | translate }}</button>
</mat-dialog-actions>
